import { APPLICATION_STATUS_TYPE } from '../constants/ApplicationStatusConstants';
import stringHelper from './stringHelper';

const APPLICATION_STATUS_DISPLAY_TEXTS = {
  [APPLICATION_STATUS_TYPE.INVITED]: 'Invited to apply',
  [APPLICATION_STATUS_TYPE.COMPLETED]: 'Received',
  [APPLICATION_STATUS_TYPE.PENDING]: 'In-progress',
  [APPLICATION_STATUS_TYPE.ACCEPTED]: 'Approved',
  [APPLICATION_STATUS_TYPE.CONDITIONALLY_APPROVED]: 'Conditionally approved',
};

const getDisplayTextForApplicationStatus = (status: string) => {
  switch (status) {
    case APPLICATION_STATUS_TYPE.INVITED:
      return APPLICATION_STATUS_DISPLAY_TEXTS[APPLICATION_STATUS_TYPE.INVITED];
    case APPLICATION_STATUS_TYPE.COMPLETED:
      return APPLICATION_STATUS_DISPLAY_TEXTS[APPLICATION_STATUS_TYPE.COMPLETED];
    case APPLICATION_STATUS_TYPE.PENDING:
      return APPLICATION_STATUS_DISPLAY_TEXTS[APPLICATION_STATUS_TYPE.PENDING];
    case APPLICATION_STATUS_TYPE.ACCEPTED:
      return APPLICATION_STATUS_DISPLAY_TEXTS[APPLICATION_STATUS_TYPE.ACCEPTED];
    case APPLICATION_STATUS_TYPE.CONDITIONALLY_APPROVED:
      return APPLICATION_STATUS_DISPLAY_TEXTS[APPLICATION_STATUS_TYPE.CONDITIONALLY_APPROVED];
    default:
      return stringHelper.sentenceCase(status);
  }
};

export { getDisplayTextForApplicationStatus, APPLICATION_STATUS_TYPE };
